import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../const";
import _ from 'lodash';
import { unAuthorized } from '../../../auth/Auth.ducks'
import { Service } from "../../../service/service"

export const POST_MENUS_REPAS_PENDING = "POST_MENUS_REPAS_PENDING";
export const POST_MENUS_REPAS_REJECTED = "POST_MENUS_REPAS_REJECTED";
export const POST_MENUS_REPAS_FULFILLED = "POST_MENUS_REPAS_FULFILLED";
export const GET_MENUS_REPAS_PENDING = "GET_MENUS_REPAS_PENDING";
export const GET_MENUS_REPAS_REJECTED = "GET_MENUS_REPAS_REJECTED";
export const GET_MENUS_REPAS_FULFILLED = "GET_MENUS_REPAS_FULFILLED";
export const UPDATE_MENUS_REPAS_PENDING = "UPDATE_MENUS_REPAS_PENDING";
export const UPDATE_MENUS_REPAS_REJECTED = "UPDATE_MENUS_REPAS_REJECTED";
export const UPDATE_MENUS_REPAS_FULFILLED = "UPDATE_MENUS_REPAS_FULFILLED";
export const DELETE_MENUS_REPAS_PENDING = "DELETE_MENUS_REPAS_PENDING";
export const DELETE_MENUS_REPAS_REJECTED = "DELETE_MENUS_REPAS_REJECTED";
export const DELETE_MENUS_REPAS_FULFILLED = "DELETE_MENUS_REPAS_FULFILLED";
export const SET_RANGE_DATE_PENDING = "SET_RANGE_DATE_PENDING";
export const SET_RANGE_DATE_REJECTED = "SET_RANGE_DATE_REJECTED";
export const SET_RANGE_DATE_FULFILLED = "SET_RANGE_DATE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_MENUS_REPAS_PENDING:
    case GET_MENUS_REPAS_PENDING:
    case UPDATE_MENUS_REPAS_PENDING:
    case DELETE_MENUS_REPAS_PENDING:
    case SET_RANGE_DATE_PENDING:


      return true;
    case POST_MENUS_REPAS_REJECTED:
    case POST_MENUS_REPAS_FULFILLED:
    case GET_MENUS_REPAS_FULFILLED:
    case GET_MENUS_REPAS_REJECTED:
    case UPDATE_MENUS_REPAS_FULFILLED:
    case UPDATE_MENUS_REPAS_REJECTED:
    case DELETE_MENUS_REPAS_REJECTED:
    case DELETE_MENUS_REPAS_FULFILLED:
    case SET_RANGE_DATE_REJECTED:
    case SET_RANGE_DATE_FULFILLED:


      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_MENUS_REPAS_PENDING:
    case POST_MENUS_REPAS_FULFILLED:
    case GET_MENUS_REPAS_PENDING:
    case GET_MENUS_REPAS_FULFILLED:
    case UPDATE_MENUS_REPAS_PENDING:
    case UPDATE_MENUS_REPAS_FULFILLED:
    case DELETE_MENUS_REPAS_PENDING:
    case DELETE_MENUS_REPAS_FULFILLED:
    case SET_RANGE_DATE_PENDING:
    case SET_RANGE_DATE_FULFILLED:

      return null;
    case POST_MENUS_REPAS_REJECTED:
    case GET_MENUS_REPAS_REJECTED:
    case UPDATE_MENUS_REPAS_REJECTED:
    case DELETE_MENUS_REPAS_REJECTED:
    case SET_RANGE_DATE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {

  switch (type) {
    case GET_MENUS_REPAS_FULFILLED:

      return _.isEmpty(payload) ? [] : payload;
    // case GET_REPAS_PENDING:
    //   return null;
    // case SET_RANGE_DATE_FULFILLED:



    default:
      return state;
  }
};

// PLANNING reducer
export default combineReducers({ loading, error, data });

export const getMenusRepas = (tok, dateStartMounth, dateEndMounth) => {
  return (dispatch) => {
     const response = Service.get(`${API}api/creche/repas?date-debut=${dateStartMounth}&date-fin=${dateEndMounth}`, {
      headers: {
        Authorization: `Bearer ${tok}`, 'Content-Type': 'application/json'
      }
    })
    response.then((res) => {
      var listRepas = []
      res.data.repasList.map((repas) => {

        if (!_.isEmpty(repas.menuDesGrands) &&!_.isEmpty(repas.menuDesPetits) ) {

          let objectRepas ={}
          let objectRepas2 ={}
          objectRepas.title = "menuDesGrands"
          objectRepas.description = repas.menuDesGrands
          objectRepas.start = repas.date
          objectRepas.end = repas.date
          objectRepas.id = repas.id
          objectRepas2.title = "menuDesPetits"
          objectRepas2.description = repas.menuDesPetits
          objectRepas2.start = repas.date
          objectRepas2.end = repas.date
          objectRepas2.id = repas.id
          listRepas.push(objectRepas)
          listRepas.push(objectRepas2)
      } else if (!_.isEmpty(repas.menuDesGrands) &&_.isEmpty(repas.menuDesPetits) ) {
        let objectRepas ={}
        objectRepas.title = "menuDesGrands"
        objectRepas.description = repas.menuDesGrands
        objectRepas.start = repas.date
        objectRepas.end = repas.date
        objectRepas.id = repas.id
        listRepas.push(objectRepas)
      } else if (_.isEmpty(repas.menuDesGrands) &&!_.isEmpty(repas.menuDesPetits) ) {
        let objectRepas2 ={}
        objectRepas2.title = "menuDesPetits"
        objectRepas2.description = repas.menuDesPetits
        objectRepas2.start = repas.date
        objectRepas2.end = repas.date
        objectRepas2.id = repas.id
        listRepas.push(objectRepas2)
      } 
    })
        dispatch({ type: GET_MENUS_REPAS_FULFILLED, payload: listRepas })

    })
    response.catch(err => {
      dispatch({ type: GET_MENUS_REPAS_REJECTED, payload: err })
      let message = !_.isEmpty(err.response) ? err.response.data.message : err.response;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const addMenusRepas = (tok, data, dates) => {
  return (dispatch) => {
    dispatch({ type: POST_MENUS_REPAS_PENDING })
    const response = Service.post(`${API}api/creche/repas`, data, {
      headers: {
        Authorization: `Bearer ${tok}`, 'Content-Type': 'application/json'
      }
    })
    response.then((res) => {
      getMenusRepas(tok, dates.start, dates.end)(dispatch)
      dispatch({ type: POST_MENUS_REPAS_FULFILLED, payload: res })
      dispatch({ type: "OPEN_SNACKBAR_SUCCESS" })


    })
    response.catch(err => {
      dispatch({ type: POST_MENUS_REPAS_REJECTED, payload: err })
      let message = !_.isEmpty(err.response) ? err.response.data.message : err.response;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const editMenusRepas = (tok, idRepas, data, dates) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_MENUS_REPAS_PENDING })
    const response = Service.put(`${API}api/creche/repas/${idRepas}`, data, {
      headers: {
        Authorization: `Bearer ${tok}`, 'Content-Type': 'application/json'
      }
    })
    response.then((res) => {
      getMenusRepas(tok, dates.start, dates.end)(dispatch)
      dispatch({ type: UPDATE_MENUS_REPAS_FULFILLED, payload: res })
      dispatch({ type: "OPEN_SNACKBAR_SUCCESS" })
    })
    response.catch(err => {
      dispatch({ type: UPDATE_MENUS_REPAS_REJECTED, payload: err })
      let message = !_.isEmpty(err.response) ? err.response.data.message : err.response;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const deleteMenusRepas = (tok, idRepas, dates) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_MENUS_REPAS_PENDING })
    const response = Service.deleteOne(`${API}api/creche/repas/${idRepas}`, {
      headers: {
        Authorization: `Bearer ${tok}`, 'Content-Type': 'application/json'
      }
    })
    response.then((res) => {
      getMenusRepas(tok, dates.start, dates.end)(dispatch)
      dispatch({ type: UPDATE_MENUS_REPAS_FULFILLED, payload: res })
      dispatch({ type: "OPEN_SNACKBAR_SUCCESS" })

    })
    response.catch(err => {
      dispatch({ type: UPDATE_MENUS_REPAS_REJECTED, payload: err })
      let message = !_.isEmpty(err.response) ? err.response.data.message : err.response;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}